import { Component, OnInit } from '@angular/core';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { ConfigService } from '../services/config.service';
import { UserService } from '../services/user.service';
import $ from 'jquery';
import { AccountService } from '../services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginDialogComponentComponent } from '../login-dialog-component/login-dialog-component.component';
import { MatDialog } from '@angular/material/dialog';
import { MembershipDialogComponent } from '../membership-dialog/membership-dialog.component';
import { Cart1Service } from '../services/cart1.service';
import { MarketSelectorComponent } from '../model/market-selector/market-selector.component';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  userServiceModal: UserServiceModal;
  islogedIn: boolean = false;
  currentRouterPath: any;

  constructor(public activatedRoute: ActivatedRoute, public configService: ConfigService, public dialog: MatDialog, public router: Router, public userService: UserService, public accountService: AccountService, private cart1Service: Cart1Service,
   ) {

    this.userServiceModal = this.userService.userServiceModal;
    this.router.events.subscribe((event) => {
      this.currentRouterPath = router.url;
    });

  }
  ngOnInit() {
    $(window).bind('scroll', function (e) {
      if ($(window).width() < 1340) {
        return;
      }
      let Thewidth = window.visualViewport.width;
      if (Thewidth < 1650 && $('#sideCartBox')[0]?.clientHeight > 350) {
        // if ($(window).scrollTop() + window.innerHeight >= $('#footer').offset().top) {

        //   if ($(window).scrollTop() + window.innerHeight < 2100) {

        //     $('#sideCartBox').css({ 'position': 'fixed', 'right': '25px', 'top': '-200px', 'bottom': 'inherit', 'left': 'inherit', 'max-height': '625px' })
        //   } else {

        //     $('#sideCartBox').css({ 'position': 'fixed', 'right': '25px', 'top': '-360px', 'bottom': 'inherit', 'left': 'inherit', 'max-height': '625px' })
        //   }
        // } else {
        //   $('#sideCartBox').css({ 'position': 'fixed', 'right': '25px', 'top': '70px', 'bottom': 'inherit', 'left': 'inherit', 'max-height': '625px' })
        // }
      } else if (Thewidth < 2200 && $('#sideCartBox')[0]?.clientHeight < 350) {

        // if ($(window).scrollTop() + window.innerHeight >= $('#footer').offset().top) {
        //   if ($('#sideCartBox')[0]?.clientHeight < 350) {
        //     $('#sideCartBox').css({ 'position': 'fixed', 'right': '25px', 'top': '-75px', 'bottom': 'inherit', 'left': 'inherit', 'max-height': '625px' })
        //   } else {
        //     $('#sideCartBox').css({ 'position': 'fixed', 'right': '25px', 'top': '-100px', 'bottom': 'inherit', 'left': 'inherit', 'max-height': '625px' })
        //   }
        // } else {
        //   $('#sideCartBox').css({ 'position': 'fixed', 'right': '25px', 'top': '100px', 'bottom': 'inherit', 'left': 'inherit', 'max-height': '625px' })
        // }
      }
    });
  }
  isLoggedIn() {
    if ((Object.keys(this.userServiceModal.customerData).length) && (this.userServiceModal.customerData.CustomerId) && this.userService.checkIfUserAuthenticatedOrNot()) {
      return true;
    } else {
      return false;
    }
  }
  logss() {
    window.open('https://office2.Tangerine.funww.com/#/Login','_blank');
    // const dialogRef = this.dialog.open(LoginDialogComponentComponent, {
    //   width: "600px",
    //   autoFocus: false
    // });

    // dialogRef.afterClosed().subscribe((result) => {
    // });
  }
  // logoutHandler() {

  //   this.accountService.logout();
  // }

  shopDialog() {
    // if (this.isLoggedIn()) {
      this.router.navigate(['/shop']);
    // } else {
    //   const dialogRef = this.dialog.open(MembershipDialogComponent, {
    //     width: '800px',
    //     height: 'auto',
    //     panelClass: 'myapp-no-padding-dialog'
    //   });

    //   dialogRef.afterClosed().subscribe(result => {
    //   });
    // }
  }

  goToJoin(type) {
    // Check if user is logged in
    if (this.isLoggedIn()) {
      return; // Don't allow enrollment if user is already logged in
    }

    if (type == 1) {
      this.router.navigate(['/join'],
        {
          relativeTo: this.activatedRoute,
          queryParams: { type },
          queryParamsHandling: 'merge'
        }).then(()=>{
          window.location.reload();
        })
    }
    else if (type == 3) {
      this.router.navigate(['/join'],
        {
          relativeTo: this.activatedRoute,
          queryParams: { type },
          queryParamsHandling: 'merge'
        }).then(()=>{
          window.location.reload();
        })
    }
  }

  openLogin(){
    this.dialog.open(LoginDialogComponentComponent, {
         width: "600px",
        autoFocus: false
       })
  }
  logout() {
    this.accountService.logout();
  }

  navigateToJoin() {
    if(!this.router.url.includes('join')){
      if(!this.isLoggedIn()){
        localStorage.getItem("cart.order")
        ? localStorage.removeItem("cart.order")
        : null;
      localStorage.getItem("cart.autoship")
        ? localStorage.removeItem("cart.autoship")
        : null;
      localStorage.getItem("cart.packs")
        ? localStorage.removeItem("cart.packs")
        : null;
      this.cart1Service.clearCart();
      this.router.navigate(['/join'], { queryParams: { type: 1 } });
      }else{
        const dialogRef = this.dialog.open(MarketSelectorComponent, {
          height: 'auto',
        });
        dialogRef.afterClosed().subscribe(result => {
          localStorage.getItem("cart.order")
          ? localStorage.removeItem("cart.order")
          : null;
        localStorage.getItem("cart.autoship")
          ? localStorage.removeItem("cart.autoship")
          : null;
        localStorage.getItem("cart.packs")
          ? localStorage.removeItem("cart.packs")
          : null;
        this.cart1Service.clearCart();
        this.router.navigate(['/join'], { queryParams: { type: 1 } });
        });
      }
    }
  }
  ShopNowMarketSelector() {
    if(!this.router.url.includes('shop')){
      // Set US as default country and navigate directly to shop
      sessionStorage.setItem('IsMarketCountrySelected', 'true');
      sessionStorage.setItem('selectedCountry', 'US');
      sessionStorage.setItem('selectedLanguageCode', 'en');
      sessionStorage.setItem('selectedCustomerTypeID', '2'); // Default customer type
      
      this.router.navigate(['/shop']).then(() => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      });
    }
  }
}
